export const assets = {
  logo: './assets/images/logo.png',
  logo2: './assets/images/logo2.png',
  adminIcon: 'assets/images/profile.png',
  placeHolderLogo: 'assets/images/placeholder.png',
  sidebarDashboardIcon: 'assets/images/dash.svg',
  viewIcon: 'assets/images/eye.svg',
  edit_icon: 'assets/images/edit_icon.svg',
  deleteIcon: 'assets/images/delete_icon.svg',
  RevenueIcon: 'assets/images/revenue.svg',
  ReveiwIcon: 'assets/images/rating.svg',
  CmsIcon: 'assets/images/cms.svg',
  LogoutIcon: 'assets/images/logout.svg',
  CategoryIcon: 'assets/images/category.svg',
  NotificationIcon: 'assets/images/notification.svg',
  searchIcon: 'assets/images/search_icon.svg',
  UsersIcon: 'assets/images/total_user.svg',
  VendorIcon: 'assets/images/vendor_icon.svg',
  ProductIcon: 'assets/images/product_icon.svg',
  OrderIcon: 'assets/images/order_icon.svg',
  AdIcon: 'assets/images/ad_icon.svg',
  AnalyticIcon: 'assets/images/analytic_icon.svg',
  CouponsIcon: 'assets/images/coupons_icon.svg',
  PropertyIcon: 'assets/images/building.png',
  ChatIcon: 'assets/images/chat.png',
  HouseIcon: 'assets/images/house.png',
  AdvertisementIcon: 'assets/images/advertising.png',
  PortfolioIcon: 'assets/images/briefcase.png',
  SubadminIcon: 'assets/images/sub-admin.png',
  LoyaltyIcon: 'assets/images/fidelity.png',
  QuestionMark: 'assets/images/reports_icon.svg',
  cameraIcon: 'assets/images/camera_icon.svg',
  restIcon: 'assets/images/rest_icon.svg',
  listIcon: 'assets/images/list_icon.png',
  ServiceProviderIcon: 'assets/images/serviceprovider.png',
  PackageIcon: 'assets/images/luggage.png',
  DestinationIcon: 'assets/images/destination.png',
  PriceIcon: 'assets/images/price.png',
  BannerIcon: 'assets/images/advertisement.png',
  DealIcon: 'assets/images/deal.png',
  ReportIcon: 'assets/images/data-analytics.png',
  ReviewIcon: 'assets/images/reports.svg',
  sendIcon: 'assets/images/send.png',
  HomestayIcon: 'assets/images/homestayicon.png',
  SettingsIcon: 'assets/images/settings.png',
  GuideIcon: 'assets/images/guide.png',
  noDataFound: 'assets/images/Nodat-found.gif',
  plus: 'assets/images/plus.png'
};
